// extracted by mini-css-extract-plugin
export default {"overlay":"PDFViewer_overlay__D-ESg","pdfContainer":"PDFViewer_pdfContainer__rAoio","closeButton":"PDFViewer_closeButton__JA9sU","controls":"PDFViewer_controls__8hNNy"};